import type { TranslationKeys } from './index';

export const ru: TranslationKeys = {
  login_hi: 'Рады тебя видеть! 👋',
  login_title: 'Войти',
  login_label: 'Вход',
  login_title2: 'Войди в свой кабинет пациента',
  login_choose: 'Введи свой номер телефона, и мы вышлем тебе одноразовый код-пароль',
  login_no_password_hint: 'Вход без пароля — быстро и безопасно',
  phone_placeholder: 'Телефон*',
  login_sub_email: 'Введите e-mail и пароль',
  forgot: 'Не помнишь пароль?',
  login_by_phone: 'Воспользуйся входом по номеру телефона',
  or: 'или',
  password: 'Пароль',
  login_btn: 'Войти',
  cont_google: 'Продолжить с Google',
  cont_apple: 'Продолжить с Apple',
  no_account: 'У тебя нет аккаунта?',
  no_account_sub: 'Зарегистрируйся — следующие заказы оформишь быстрее, а визиты и документы будут в одном месте',
  create_account: 'Создать аккаунт',
  reg_title: 'Создать аккаунт',
  reg_sub: 'Укажи свои данные, чтобы создать аккаунт пациента.',
  firstname: 'Имя',
  lastname: 'Фамилия',
  id_doc: 'PESEL или паспорт',
  pesel: 'PESEL',
  passport: 'Паспорт',
  reg_btn: 'Создать аккаунт',
  consent1: 'Принимаю Регламент и Политику конфиденциальности',
  consent2: 'Даю согласие на обработку моих данных для оказания медицинских услуг',
  reg_phone_title: 'Создать аккаунт',
  reg_phone_sub: 'Введите номер телефона, а мы отправим вам SMS-код',
  reg_firstname: 'Имя',
  reg_lastname: 'Фамилия',
  consent1_text: 'Принимаю <a href="/regulamin/">Регламент</a> и <a href="/polityka-prywatnosci/">Политику конфиденциальности</a>',
  consent2_text: 'Даю согласие на обработку моих данных в целях оказания медицинских услуг',
  no_account_yet_msg: 'Кабинет пациента создадим автоматически после первой оплаты — тогда войдёшь по SMS-коду. Оформи заказ ниже.',
  login_no_account_msg: 'Аккаунт с таким номером телефона не найден. Перейдите к регистрации',
  err_firstname_empty: 'Введите имя',
  err_lastname_empty: 'Введите фамилию',
  err_consent_required: 'Обязательное согласие',
  reg_login_link: 'Уже есть аккаунт — войти',
  otp_title: 'Введите код из SMS',
  otp_sub: 'Мы отправили 4-значный код на твой номер телефона',
  confirm: 'Подтвердить',
  resend: 'Отправить код еще раз',
  phone_label: 'Номер телефона',
  send_sms_btn: 'Отправить код SMS',
  change_number: 'Изменить номер',
  otp_sent_hint: 'Мы отправили код на {phone}',
  resend_timer: 'Отправить снова ({time})',
  err_phone_empty: 'Введите номер телефона',
  err_phone_format: 'Неверный формат номера',
  err_sms_failed: 'Не удалось отправить код. Попробуйте еще раз',
  err_otp_invalid: 'Неверный код. Попробуйте еще раз',
  err_otp_expired: 'Код устарел — отправь новый',
  err_otp_rate_limit: 'Слишком много попыток. Подождите минуту',
  reset_pw_title: 'Сбросить пароль',
  reset_pw_sent: 'Если аккаунт существует, мы отправили ссылку',
  login_with_sms: 'Войти по SMS',
  login_with_email: 'Войти по e-mail и паролю',
  err_network: 'Возникла ошибка сети. Если вы получили SMS-код, перейдите далее.',
  err_fill_all_to_enter_code: 'Заполните все поля правильно, чтобы иметь возможность ввести код',
  err_phone_to_enter_code: 'Введите номер телефона, чтобы иметь возможность ввести код.',
  btn_have_code: 'У меня уже есть SMS-код',
  thanks_title: 'Спасибо за оплату!',
  thanks_sub: 'Заказ оплачен. Подтверждение отправили на e-mail. Аккаунт пациента уже готов.',
  go_account: 'Перейти в аккаунт',
  go_back: 'Назад',
  nav_cons: 'Мои консультации',
  nav_cons_short: 'Консультации',
  nav_terapia: 'Моя терапия',
  nav_terapia_short: 'Терапия',
  nav_uslugi: 'Услуги',
  nav_uslugi_s: 'Услуги',
  nav_umow: 'Записаться',
  btn_umow: 'Записаться',
  nav_doc: 'Документы',
  nav_dane: 'Мои данные',
  logout: 'Выйти',
  greet_title: 'Добро пожаловать, {name}! 👋',
  greet_sub: 'Твои визиты, данные и документы — всё в одном месте',
  cons_actual: 'Актуальные',
  cons_done: 'Завершённые',
  status_upcoming: 'Предстоящая',
  status_done: 'Завершена',
  cons_cancelled: 'Аннулированные',
  status_cancelled: 'Аннулирована',
  status_pending: 'Ожидает оплаты',
  pay_for_visit: 'Оплатить визит',
  status_nieudane: 'Неудачная',
  contact_support: 'Связаться с нами',
  order_no: '№ заказа',
  show_more: 'Показать больше',
  show_less: 'Свернуть',
  weight: 'Вес',
  by_phone: 'По телефону',
  online: 'Онлайн',
  reschedule: 'Перенести визит',
  rebook: 'Повторная запись',
  empty_cons: 'У тебя пока нет визитов',
  empty_cons_sub: 'Начни с первой консультации — мы рядом 💜',
  empty_cons_cta: 'Записаться на визит',
  visit_summary: 'Итоги визита',
  cons_empty_tab: 'В этой вкладке нет консультаций.',
  cons_show_more: 'Показать больше ({count})',
  cons_collapse: 'Свернуть',
  spec1: 'Врач · терапия ожирения',
  spec_tele: 'Врач · семейная медицина',
  cons_find_point: 'Найти пункт',
  cons_checkup_results_btn: 'Выбери время для разговора',
  cons_find_point_link: 'https://tabletka24.pl/uk/map-synevo-ua/',
  cons_download_referral: 'Скачать направление',
  terapia_title: 'Твоя терапия, шаг за шагом',
  terapia_intro: 'Здесь мы собрали все полезные ссылки и информацию, которые могут пригодиться во время терапии GLP-1.',
  last_visit: 'Последний визит',
  rec_control: 'Рекомендуемый контрольный визит',
  book_control: 'Записаться на контроль',
  uslugi_title_a: 'Посмотри, чем ещё мы можем тебе помочь',
  cs_recepta: 'Электронный рецепт',
  cs_recepta_d: 'Лекарство от аллергии, простуды или инфекции? Получи быстро э-рецепт онлайн — <strong>59 zł</strong>',
  cs_anty: 'Контрацепция',
  cs_anty_d: 'Твоя контрацепция всегда под рукой — э-рецепт онлайн за <strong>59 zł</strong>',
  cs_l4: 'Больничный (L4)',
  cs_l4_d: 'Неважно себя чувствуешь и нужен отдых? Врач оформит L4 онлайн — <strong>79 zł</strong>',
  cs_tele: 'Телеконсультация',
  cs_tele_d: 'Инфекция, боль или простуда? Поговори с врачом онлайн — <strong>79 zł</strong>',
  cs_check: 'Онлайн чекап с Synevo',
  cs_check_d: 'Позаботься о себе заранее — пакеты анализов <strong>от 259 zł</strong>',
  glp_t: 'Терапия похудения (GLP-1)',
  glp_d: 'Пробовала уже всё, а вес стоит на месте? Комплексная терапия GLP-1 <strong>от 199 zł</strong>',
  svc_analizy: 'Контрольные анализы',
  svc_analizy_d: 'Пора проверить, как организм реагирует на терапию? Пакет анализов в Synevo — <strong>299 zł</strong>',
  svc_portal: 'Портал о терапии GLP-1',
  svc_portal_d: 'Хочешь понять, как работают аналоги GLP-1? Загляни в портал знаний',
  doc_all: 'Все',
  doc_recepty: 'Рецепты',
  doc_skier: 'Направления',
  doc_wyniki: 'Результаты анализов',
  doc_moje: 'Мои файлы',
  doc_l4: 'Больничные',
  doc_zalecenia: 'Рекомендации',
  add_file: 'Добавить файл',
  empty_doc: 'Здесь появятся твои документы',
  add_file_sub: 'Добавь документ — врач увидит его во время консультации',
  upload_txt: 'Перетащи файл или нажми здесь',
  upload_max: '(Макс. размер файла: 100 МБ)',
  upload_formats: 'Доступные форматы: .pdf, .jpg, .jpeg, .png, .doc, .docx',
  upload_blocked_hint: 'Возможность добавления файлов разблокируется после первой консультации',
  doc_delete_confirm: 'Вы уверены, что хотите удалить этот файл?',
  doc_title_desktop: 'Документы',
  doc_title_mobile: 'Документация',
  doc_no_files: 'Нет файлов',
  doc_default_name: 'Документ',
  doc_upload_title: 'Загрузить новый документ',
  doc_close: 'Закрыть',
  doc_choose_file: 'Выбрать файл с устройства',
  doc_uploaded_file: 'Загруженный файл',
  doc_delete_selected: 'Удалить выбранный файл',
  doc_send_to_doctor: 'Отправить врачу',
  doc_prescription_title: 'Рецепт',
  doc_prescription_code: 'Код рецепта',
  doc_code: 'Код',
  doc_pickup_title: 'Как получить лекарство в аптеке?',
  doc_pickup_desc_1: 'Достаточно назвать фармацевту ',
  doc_pickup_desc_2: 'номер PESEL',
  doc_pickup_desc_3: ' и ',
  doc_pickup_desc_4: 'код рецепта',
  doc_prescriptions_heading: 'РЕЦЕПТЫ',
  doc_download_pdf: 'Скачать (PDF)',
  doc_print_save_pdf: 'Печать / Сохранить PDF',
  doc_all_files: 'Все файлы',
  dane_personal: 'Персональные данные',
  dane_addr: 'Адресные данные',
  dane_contact: 'Контактные данные',
  security: 'Безопасность',
  sex: 'Пол',
  female: 'Женщина',
  male: 'Мужчина',
  tz: 'Часовой пояс',
  street: 'Улица',
  city: 'Город',
  country: 'Страна',
  phone_short: 'Телефон',
  err_phone: 'Неверный номер телефона',
  edit: 'Изменить',
  change: 'Изменить',
  cancel: 'Отмена',
  save: 'Сохранить',
  edit_your: 'Измени свои данные',
  resch_title: 'Перенести визит',
  resch_intro: 'Твои планы изменились? Перенеси консультацию в пару кликов.',
  resch_current: 'Твоё новое время',
  resch_doctor: 'Выбери врача',
  resch_pick: 'Выбери время',
  resch_confirm: 'Подтвердить новое время',
  resch_ok_t: 'Визит перенесён',
  resch_ok_s: 'Твой визит перенесён. Подтверждение отправили на e-mail',
  back_cons: 'Назад к консультациям',
  toast_soon: 'Скоро будет доступно',
  toast_portal: 'Переход в портал знаний…',
  toast_added: 'Файл добавлен',
  toast_saved: 'Изменения сохранены',
  toast_pass: 'Открываю смену пароля…',
  toast_deleted: 'Файл удален',
  verify_email_banner: 'Подтверди свой e-mail, чтобы получить доступ к медицинской документации.',
  verify_email_cta: 'Отправить ссылку для подтверждения',
  verify_email_sent: 'Ссылку отправили на твой e-mail.',
  verify_email_title_existing: 'Подтверди e-mail и задай пароль',
  verify_email_sub_existing: 'В твоём аккаунте уже есть e-mail. Подтверди его и задай пароль, чтобы входить не только по SMS-коду, но и по e-mail.',
  set_new_password_title: 'Установите новый пароль',
  set_new_password_sub: 'Введите новый пароль для вашего аккаунта',
  new_password_placeholder: 'Новый пароль (мин. 8 символов)',
  confirm_password_placeholder: 'Повторите новый пароль',
  set_password_btn: 'Сохранить пароль',
  password_set_success: 'Пароль успешно изменен! Выполняется вход...',
  err_password_short: 'Пароль должен содержать не менее 8 символов.',
  err_passwords_mismatch: 'Введенные пароли не совпадают',
  my_account: 'Мой аккаунт',
  passport_no: 'Серия и номер паспорта',
  issue_country: 'Страна выдачи',
  issue_date: 'Дата выдачи',
  building: 'Номер дома/квартиры',
  zipcode: 'Почтовый индекс',
  email: 'E-mail',
  push_notif: 'Push-уведомления',
  push_off_toast: 'Уведомления отключены',
  push_on_toast: 'Уведомления включены',
  push_err_toast: 'Ошибка активации уведомлений',
  turn_off: 'Выключить',
  turn_on: 'Включить',
  add_email_title: 'Добавьте e-mail к аккаунту',
  add_email_sub: 'Ваш аккаунт зарегистрирован только по номеру телефона. Добавьте e-mail, чтобы иметь возможность войти и восстановить пароль.',
  add_email_btn: 'Добавить e-mail',
  err_email_send: 'Ошибка отправки письма. Попробуйте еще раз.',
  terms_link: 'Ознакомься с <u>Регламентом сервиса</u>',
  privacy_link: 'Ознакомься с <u>Политикой конфиденциальности</u>',
  error_save: 'Произошла ошибка при сохранении',
  sending: 'Отправка...',
  poland: 'Польша',
  ther_welcome_sub: 'Ниже найдёшь всё необходимое для терапии похудения препаратами GLP-1',
  ther_next_visit: 'Следующий контрольный визит',
  ther_rec_date: 'Рекомендуемая дата:',
  ther_book_visit: 'Записаться на контроль',
  ther_my_visits: 'Мои визиты',
  ther_visits_desc: 'История и предстоящие консультации',
  ther_tests: 'Контрольные анализы',
  ther_tests_desc: 'Сделайте специальный пакет анализов для терапии в Synevo - 299 zł',
  ther_portal: 'Портал знаний о терапии',
  ther_portal_desc: 'Как использовать препараты, о питании и физической активности',
  ther_extra_services: 'Дополнительные услуги',
  ther_extra_services_desc: 'Закажите консультации с диетологом, план питания',
  doc_delete_err: 'Не удалось удалить файл',
  doc_delete_btn: 'Удалить',
  thanks_desc: 'Твой запрос принят. О следующих шагах сообщим тебе по электронной почте и в уведомлениях.',
  thanks_no_order: 'Спасибо за заказ! Детали найдёшь в своём аккаунте.',
  back_to_dashboard: 'Вернуться на главную',
  sick_note_from_to: '<span style="font-size: 12px;">с</span> {from} <span style="font-size: 12px;">по</span> {to}',
  err_load_slots: 'Произошла ошибка при загрузке времени.',
  err_resch: 'Ошибка при переносе визита.',
  resch_ok_p1: 'Ваш визит перенесен на {date}.',
  resch_ok_p2: 'Подтверждение мы отправили на email.',
  med_cons: 'Медицинская консультация',
  loading_slots: 'Загрузка времени…',
  no_avail_slots: 'Нет свободного времени',
  resch_new_time: 'Ваше новое время',
  any_doctor: 'Любой врач',
  doc_placeholder: 'Врач',
  resch_select_date: 'Выбрать',
  weekdays_short: 'Пн,Вт,Ср,Чт,Пт,Сб,Вс',
  synevo_any_point: 'Выполните в любом отделении Synevo',
  pwa_banner_title: 'Установите приложение',
  pwa_banner_sub: 'Добавь приложение на главный экран и <strong>получи -15%</strong> на первый заказ с приложения',
  pwa_banner_how: 'Как установить?',
  pwa_exp_title: 'Установите приложение Tabletka24',
  pwa_exp_sub: 'Установи приложение, <strong>получи -15% на заказ</strong> и пользуйся дополнительными бонусами и уведомлениями',
  pwa_welcome_coupon: 'Привет! Получи -15% на первый заказ с приложения по коду <b>WELCOME15</b>',
  pwa_back: 'Назад',
  pwa_s_1: '1. Нажмите кнопку внизу экрана',
  pwa_s_2: '2. Затем нажмите кнопку',
  pwa_s_2_badge: 'Поделиться',
  pwa_s_3: '3. Прокрутите меню и выберите',
  pwa_s_3_badge: 'Добавить на экран «Домой»',
  pwa_s_4: '4. Введите название и нажмите кнопку',
  pwa_s_4_badge: 'Добавить',
  pwa_s_4_end: 'в правом верхнем углу',
  pwa_ci_1: '1. Нажмите кнопку вверху экрана',
  pwa_ci_1_mid: 'или найдите кнопку',
  pwa_ci_1_badge: 'Показать больше',
  pwa_ca_1: '1. Нажмите меню',
  pwa_ca_1_end: 'в правом верхнем углу',
  pwa_ca_3: '3. Подтвердите, нажав',
  pwa_ca_3_badge1: 'Установить',
  pwa_ca_3_mid: 'или',
  pwa_ca_3_badge2: 'Добавить',
  tour_back: 'Назад',
  tour_next: 'Далее',
  tour_finish: 'Готово',
  tour_welcome: 'Привет! Добро пожаловать в твой кабинет пациента 👋 За несколько шагов покажем, что и где найдёшь.',
  tour_notif: 'Здесь твои уведомления — сообщим, когда появятся результаты анализов, новые документы или рекомендации врача.',
  tour_a1: 'Здесь напомним о рекомендуемой дате контрольного визита — запишешься в один клик.',
  tour_a2: 'В «Моих консультациях» — полная история визитов: перенесёшь время и запишешься снова. Там же откроешь итог каждого визита — рекомендации врача и документы.',
  tour_a3: 'Во вкладке «Услуги» закажешь наши дополнительные услуги помимо терапии — э-рецепт, телеконсультацию, L4 или пакет анализов.',
  tour_a4: 'В «Документах» — твои рецепты, направления, рекомендации врача и результаты анализов. Можно добавить и свой файл.',
  tour_a5: 'В «Моих данных» изменишь свои данные, задашь пароль для входа и изменишь настройки аккаунта.',
  tour_b1: 'В «Записаться» закажешь э-рецепт, телеконсультацию, L4, контрацепцию или пакет анализов.',
  tour_b2: 'В «Консультациях» — история визитов и заказов: перенесёшь время, а также откроешь итог визита — рекомендации врача и документы.',
  tour_b3: 'В «Документах» — твои рецепты, больничные, направления и результаты анализов.',
  tour_b4: 'В «Моих данных» изменишь свои данные, задашь пароль для входа и изменишь настройки аккаунта.',
  tour_pwa: 'Установи кабинет как приложение на главный экран телефона — будешь открывать его одним касанием, как обычное приложение.',
  loading_dots: 'Загрузка...',
  err_login_invalid: 'Неверный адрес e-mail или пароль',
  email_placeholder: 'E-mail*',
  show_hide_password: 'Показать/скрыть пароль',
  err_email_invalid: 'Введите корректный адрес e-mail.',
  err_firstname_latin: 'Пожалуйста, введите имя латиницей (напр. Natalia).',
  err_lastname_latin: 'Пожалуйста, введите фамилию без пробелов и латиницей (напр. Kovalchuk).',
  err_email_exists: 'Этот e-mail уже занят.',
  err_rate_limit_10m: 'Слишком много попыток. Подождите 10 минут.',
  err_register_failed: 'Регистрация не удалась. Попробуйте еще раз.',
  err_reset_send: 'Ошибка при отправке ссылки.',
  powrot: 'Назад',
  reset_pw_sub: 'Введите e-mail, чтобы сбросить пароль.',
  err_set_password: 'Ошибка при установке пароля. Ссылка могла устареть.',
  auth_ready: 'Готово!',
  auth_redirect_msg: 'Аккаунт успешно создан. Сейчас тебя перенаправим...',
  push_prompt_msg: 'Хотите включить push-уведомления, чтобы не пропустить важную информацию?',
  notifications: 'Уведомления',
  no_notifications: 'Нет уведомлений',
  err_phone_min9: 'Укажите правильный номер телефона (мин. 9 цифр)',
  err_street_invalid: 'Укажите правильное название улицы',
  err_city_invalid: 'Укажите правильное название города',
  house_number: 'Номер дома/помещения',
  zip_code: 'Почтовый индекс',
  empty_cons_btn: 'Записаться на визит',
  empty_cons_title: 'У вас еще нет визитов',
  dr_prefix: 'Врач',
  synevo_package: 'Пакет анализов в Synevo',
  blood_tests_package: 'Пакет анализов крови',
  doctor_alt: 'Врач',
  err_fetch_recommendations: 'Не удалось получить рекомендации',
  doctor_recommendations: 'Рекомендации врача',
  dietitian_recommendations: 'Рекомендации диетолога',
  visit_no: 'Визит',
  no_recommendations: 'Нет рекомендаций для этого визита.',
  err_upload_file: 'Ошибка при загрузке файла',
  no_visit_data: 'Нет данных о визите.',
  diagnosis: 'Диагноз',
  e_prescription: 'Электронный рецепт',
  e_prescription_code: 'Код э-рецепта:',
  referrals_title: 'Направления',
  code_label: 'Код:',
  test_results_docs: 'Результаты анализов / Документы',
  password_placeholder: 'Пароль*',
  prescription_title: 'Рецепт',
  referral: 'Направление',
  print_save_pdf: 'Печать / Сохранить PDF',
  close: 'Закрыть',
  push_later: 'Позже',
  doc_referral_title: 'Направление',
  doc_referral_code: 'Код э-направления',
  doc_referral_type: 'Тип направления',
  doc_referral_diseases: 'Диагнозы',
  doc_referral_procedures: 'Исследования / Процедуры',
  doc_referral_reason: 'Причина направления',
  doc_referral_notes: 'Дополнительные примечания',
  doc_referral_urgent: 'Срочное',
  doc_referral_empty: 'Нет направлений для этого визита.',
  doc_referral_card_label: 'Направление',
  diet_need_advice: 'Нужен совет диетолога?',
  diet_need_advice_sub: 'Проконсультируйтесь с нашим экспертом или закажите индивидуальное меню, адаптированное к вашим потребностям.',
  diet_check_offer: 'Посмотреть предложение',
  diet_plan_title: 'Ваш план питания',
  diet_plan_ready: 'Готово',
  diet_plan_prep: 'В разработке',
  diet_plan_prep_desc: 'Диетолог готовит ваше меню. Мы сообщим вам по электронной почте (обычно до 2 дней).',
  diet_plan_slot: '📅 Запланированная консультация: {slot}',
  diet_plan_desc: 'Меню на 30 дней от диетолога — с рецептами и списком покупок.',
  diet_plan_open: 'Открыть план',
  diet_plan_download: 'Скачать PDF',
  diet_plan_reorder: 'Заказать следующий месяц (99 zł)',
  diet_plan_meet: 'Консультация: Google Meet',
  diet_plan_zalecenia: 'Рекомендации от диетолога:',
};
